import { showAlert as ShowAlert, showNotification as _showNotification } from "@idexcel-technologies-pvt-ltd/cync-los-common-components";
import * as svgIcons from "@fortawesome/free-solid-svg-icons";

export const showNotification = ({ data, duration = 5000 }, readNotifCallback) => {
  data.webIcon = svgIcons[data.webIcon];
  _showNotification({ data, duration }, readNotifCallback);
}
export default ShowAlert;
